<template>
  <v-app style="margin: 0 auto;" :class="screenSizeCssClass" >

      <v-navigation-drawer
              absolute
              temporary
              left
              fixed
              v-model="drawer"
              style="max-height:120vh;position:fixed;direction: ltr;"
      >
          <template v-slot:prepend>
              <v-list-item two-line>
                  <v-img
                          alt="GameEnable"
                          class="shrink mr-2 logo-large"
                          contain
                          src="../assets/logo/one-line-light.svg"

                          style="  margin-top: -22px; margin-left: -4px;"
                          width="130"

                  />
              </v-list-item>
          </template>

          <v-divider></v-divider>

          <v-list dense>
              <router-link  style="text-decoration: none;"  v-for="item in navigationItems"
                             :key="item.title"
                              :to="item.to">
              <v-list-item>

                     <v-list-item-icon style="margin-left: 0px!important;margin-right: 32px!important;">
                         <v-icon>{{ item.icon }}</v-icon>
                     </v-list-item-icon>

                     <v-list-item-content>
                         <v-list-item-title>{{ item.title }}</v-list-item-title>
                     </v-list-item-content>
              </v-list-item>
              </router-link>
          </v-list>

          <template v-slot:append>
              <div class="pa-2">
                  <Div style="        margin-top: -45px;" class="float-right"> <v-btn href="mailto: gameenable.com@gmail.com" icon>
                      <v-icon>mdi-email</v-icon>
                  </v-btn>
                      <v-btn icon target="_blank" href="https://twitter.com/enablegame">
                          <v-icon>mdi-twitter</v-icon>
                      </v-btn>
                      <v-btn icon target="_blank" href="https://discord.gg/V6fv3Nx">
                          <v-icon>mdi-discord</v-icon>
                      </v-btn></Div>
              </div>
          </template>

      </v-navigation-drawer>
    <v-row
            app
            :class="$router.currentRoute.name.indexOf('Home') === 0? 'header-dark' : ''"
            style="max-height: 80px;z-index:2;position: relative;margin: 0;"
    >
      <v-col cols="12" class="page-content  ">
        <div class="d-flex align-center float-left">
            <router-link v-if="useLargeIcon" :to="{ name: 'Home', params: { lang: this.$i18n.locale }}">

                <v-img
                        v-if="$router.currentRoute.name.indexOf('Home') === 0"
                        alt="GameEnable"
                        class="shrink mr-2 logo-large"
                        contain
                        src="../assets/logo/one-line-dark.svg"

                        style=" margin-bottom: -20px; margin-top: 12px; margin-left: 10px;"
                        width="190"


                />
                <v-img
                        v-if="$router.currentRoute.name.indexOf('Home') !== 0"
                        alt="GameEnable"
                        class="shrink mr-2 logo-large"
                        contain
                        src="../assets/logo/one-line-light.svg"

                        style=" margin-bottom: -20px; margin-top: 12px; margin-left: 10px;"
                        width="190"


                />
            </router-link>
            <v-btn v-if="!useLargeIcon" icon color="pink" @click="drawer=true" style="position: relative; top: 10px; left: 14px;">
                <v-icon size="40" >mdi-menu</v-icon>
            </v-btn>

        </div>

        <v-spacer></v-spacer>

        <div v-if="useLargeIcon" style="position: absolute; left: 170px; right: 170px; margin: 16px auto auto; text-align: center;">
          <router-link :to="{ name: 'Home', params: { lang: this.$i18n.locale }}" tag="button" class="header-link with-underline" style="margin-right:20px;"><p v-html="$t('header.homeLink')"></p></router-link>
          <router-link :to="{ name: 'Frequently asked questions', params: { lang: this.$i18n.locale }}" tag="button" class="header-link with-underline" style="margin-right:20px;"><p v-html="$t('header.faqLink')"></p></router-link>
          <router-link :to="{ name: 'Blog', params: { lang: this.$i18n.locale }}" tag="button" class="header-link with-underline" style="margin-right:20px;"><p v-html="$t('header.blogLink')"></p></router-link>
        </div>



        <!--<div style="-->
        <!--"> Get StadiaGate </div>-->


        <div style="cursor: pointer; padding: 12px 24px;margin-top: 4px;margin-bottom: -14px;"
                class="float-right header-link hidden-sm-and-down"

             @click.stop="signInDialog = true"
                v-if="!signedIn"
                v-ga-event="['User Activity', 'SignIn', 'Home page - header', 1]"
        >
          <span v-html="$t('header.signIn')"></span>
        </div>
        <v-img v-if="!useLargeIcon && $router.currentRoute.name.indexOf('Home') === 0"
            alt="GameEnable"
            class="shrink logo-large"
            contain
            src="../assets/logo/one-line-dark.svg"

            style="position:absolute; margin: 0 auto; left:0; right:0; top:32px;"
            width="130"

        />  <v-img v-if="!useLargeIcon && $router.currentRoute.name.indexOf('Home') !== 0"
            alt="GameEnable"
            class="shrink logo-large"
            contain
            src="../assets/logo/one-line-light.svg"

            style="position:absolute; margin: 0 auto; left:0; right:0; top:32px;"
            width="130"

        />
        <router-link v-if="signedIn && useLargeIcon"  class="float-right header-link" style="padding-right:5px;height:38px; " :to="{ name: 'Account', params: { lang: this.$i18n.locale }}" tag="button">  <div class="my-2">
          <v-btn icon color="pink">
            <v-icon size="40" >mdi-account-circle</v-icon>
          </v-btn>
        </div></router-link>
        <LanguageSwitcher></LanguageSwitcher>
      </v-col >
    </v-row>

    <v-main  :class="screenSizeCssClass" style="display: flex; flex-direction: column; ">

      <router-view :class="routerViewCssClass" @tryItNowDialogOpen="signInDialog = true" ></router-view>

      <privacy :isOpen="privacyModalOpen" @close="privacyModalOpen = false"></privacy>
      <terms-of-use :isOpen="termsModalOpen" @close="termsModalOpen = false"></terms-of-use>
      <v-footer
              class="footer-page"
              inset
              light
              padless


      >
        <v-card
                flat
                tile
                class="white lighten-1 text--black text-center"
                style="    width: 100%;"
        >


          <v-flex>
            <v-col lg="6" md="12" class="float-left" style="border-right:1px solid #cecece">
              <v-card-title> <p v-html="$t('footer.freeTrialClaimTitle')"></p></v-card-title>
              <v-card-text class="black--text pt-0 text-left">
                 <p v-html="$t('footer.freeTrialClaimSubtitle')"></p>
              </v-card-text>


            </v-col>

            <v-col lg="6" md="12" class="float-right">      <v-card-text class="black--text pt-0 text-left">
              <v-divider class="hidden-md-and-up" style="margin-bottom:40px;"></v-divider>
              <p v-html="$t('footer.enjoyFeaturesTitle')"></p>
              <v-list style="margin-top:10px;background:transparent;" >

                <v-list-item-content

                        v-for="subItem in [ {title: $t('footer.enjoyFeatures24Hours'), soon: false }, { title: $t('footer.enjoyFeaturesUnlimitedConnections'), soon: false }, { title: $t('footer.enjoyFeaturesConnectAnywhere'), soon: false }]"
                        :key="subItem.title"
                        style="max-height: 30px; display: block;padding:2px;font-size:14px;height:30px;">
                  <v-list-item-title class="text-left"> <v-icon class="text-action "  v-text="'mdi-check-circle'" ></v-icon>
                    {{subItem.title}} </v-list-item-title>
                </v-list-item-content>
              </v-list>
            </v-card-text>
            </v-col>
          </v-flex>


          <v-card-text class="pink--text text-left" style="position: relative;">

            <a class="pink--text" style="margin-left:12px;margin-right:15px;" @click="privacyModalOpen=true"><span v-html="$t('footer.privacyPolicy')"></span></a>  <a class="pink--text" @click="termsModalOpen=true"><span v-html="$t('footer.termsOfUse')"></span></a>
          </v-card-text>
        </v-card>
      </v-footer>
    </v-main>
    <sign-in-dialog @completed="signInCompleted" v-model="signInDialog" ></sign-in-dialog>
      <v-snackbar
              :timeout="-1"
              v-model="languageSuggentionSnack"
              :vertical="true"
              large
              left
              bottom


      >
          <v-icon class="mx-2" size="38" dark style="margin-right: 20px!important;">mdi-translate</v-icon>
          <span   class="language-suggestion-snackbar">
              {{getText('websiteAvailableSnackbar.thisWebsiteIsAvailableInLanguage')}}
          </span>



          <template v-slot:action="{ attrs }">
              <v-btn
                        class="snackbar-close-button"
                      text
                      v-bind="attrs"
                      @click="dismissLanguageSuggentionSnack"

              >
                  <!--{{$te('websiteAvailableSnackbar.dismiss', browserLanguage)}}-->

                  {{getText('websiteAvailableSnackbar.dismiss')}}
              </v-btn>
              <v-btn
                      color="pink"
                      text
                      v-bind="attrs"
                      @click="onLanguageSuggentionSnackChange"
              >
                  <!--{{$te('websiteAvailableSnackbar.change', browserLanguage)}}-->
                  {{getText('websiteAvailableSnackbar.change')}}
              </v-btn>
          </template>
      </v-snackbar>
  </v-app>
</template>

<style>

  html,
  body {
    overflow-x: hidden;
  }

  .page-content {
      max-width: 1279px;
      position:relative;
      margin:0 auto;
  }


  .text-action {

    color: #EF44AE;
      background: linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

  }

  .header-dark .header-link {

      color: #fff;

  }
  .header-link {
        outline:0;
      color: #333;
      font-family: -apple-system,BlinkMacSystemFont,"Nunito Sans",sans-serif;
      font-size: 16px;
      font-weight: 700;
      position:relative;

  }


  .header-link.with-underline::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 2px;
       bottom: 10px;
      left: 0;
      background-color: #000;
      visibility: hidden;
      transform: scaleX(0);
      transition: all 0.3s ease-in-out 0s;
      background:linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%)!important;
  }

  .header-link.with-underline:hover::before {
      visibility: visible;
      transform: scaleX(1);
  }

  .footer-page{
    left:0;right:0;margin:auto;    max-width: 1286px;position: absolute;
  }

  .mobile .footer-page, .small-screen .footer-page {

    position:static;
     bottom: 0!important;

  }

  .language-suggestion-snackbar {
      font-size: 17px !important;
  }
  .mobile .language-suggestion-snackbar {
      float: right;
      margin-top: 10px;
      line-height: 1.5;
  }

  .small-screen .logo-large, .mobile .logo-large{
    width: 130px; margin-top: 0px; margin-bottom: -22px; margin-left: 15px;
  }

 .small-screen .try-now-header, .mobile .try-now-header{
  margin-right:15px;

}
  .padding10 {
    padding-left:10px;
    padding-right:10px;
  }
  .wrap-text {
      -webkit-line-clamp: unset !important;
  }
  .snackbar-close-button{
      margin-left:50px;
  }
  .rtl.v-application .snackbar-close-button{
      margin-right:50px;
      margin-left:0px;
  }

</style>

<script>

  import { mapState } from 'vuex'
  import Privacy from '../components/privacy'
  import TermsOfUse from '../components/terms'
  import LanguageSwitcher from '../components/languageSwitcher'
  import SignInDialog from '../dialogs/signIn'

  export default {
    name: 'Page',
    components: {
      Privacy,
      TermsOfUse,
	  LanguageSwitcher,
     SignInDialog
    },

    data: () => ({
      termsModalOpen: false,
      privacyModalOpen: false,
        signInDialog: false,
        drawer: false,
        languageSuggentionSnack: false,
    }),
    methods: {
        getText(key){
            const i18n = this.$i18n;
            return i18n._t(key, 'en', i18n._getMessages(), this)
        },
        signInCompleted(payload){
            this.signInDialog = false;

            this.$store.dispatch('signIn', payload);
            this.$router.push({name: 'Account', params: { lang: this.$i18n.locale }});

        },
        onLanguageSuggentionSnackChange(){
            this.dismissLanguageSuggentionSnack();

            this.$store.dispatch('setLocale', this.browserLanguage);
            localStorage.localePreferance = this.browserLanguage;

        },dismissLanguageSuggentionSnack(){

            this.languageSuggentionSnack = false;
            localStorage.languageSuggestionCompleted = "1";
            this.$store.dispatch('setLocale', this.browserLanguage);

        },
    },

    created() {
      if (!localStorage.referrer) {
          localStorage.referrer = document.referrer || 'Direct' ;
      }

      if (!localStorage.affiliate) {
        localStorage.affiliate = this.$route.query.affiliate || 'Direct';
      }

        //Set initial RTL/LTR based on the path :locale
        this.browserLanguage = navigator.language.split('-')[0].toLowerCase();

        this.languageSuggentionSnack = false;
        //this.languageSuggentionSnack = this.$route.params.locale.toLowerCase() !== this.browserLanguage && !localStorage.languageSuggestionCompleted && !localStorage.localePreferance;


    },

    computed: {
      ...mapState(['signedIn']),
        navigationItems(){
          let items =  [
              { title: this.$t('header.homeLink'), icon: 'mdi-home', to:{ name: 'Home', params: { lang: this.$i18n.locale }} },
              { title:  this.$t('header.faqLink'), icon: 'mdi-frequently-asked-questions' , to:{ name: 'Frequently asked questions', params: { lang: this.$i18n.locale }} },
              { title: this.$t('header.blogLink'), icon: 'mdi-post', to: { name: 'Blog', params: { lang: this.$i18n.locale }}}
          ];

          if(this.signedIn){

              items.push( { title: this.$t('header.accountLink'), icon: 'mdi-account', to: { name: 'Account', params: { lang: this.$i18n.locale }}});

          }

          return items;
        },
      useLargeIcon () {
        return ['xs','sm'].indexOf(this.$vuetify.breakpoint.name) === -1
      },
      routerViewCssClass () {
        return {
          padding10: ['xs','sm'].indexOf(this.$vuetify.breakpoint.name) > -1,
          mobile: ['xs'].indexOf(this.$vuetify.breakpoint.name) > -1,
          'small-screen': ['md', 'sm'].indexOf(this.$vuetify.breakpoint.name) > -1
        }
      }, screenSizeCssClass () {
        return {
          mobile: ['xs'].indexOf(this.$vuetify.breakpoint.name) > -1,
          'small-screen': ['md', 'sm'].indexOf(this.$vuetify.breakpoint.name) > -1
        }
      }


    }
  };
</script>
